<template>
    <div class="upload-picture-modal">
        <b-modal
            id="id-card-preview-popup"
            title="Document Preview"
            size="md"
            ok-only
            ok-title="Close"
            ok-variant="primary"
            no-close-on-backdrop
            no-close-on-esc
        >
            <h5>ID Card</h5>

            <div class="document-preview-section">
                <div
                    v-if="item && item.fileName"
                    class="preview-video text-center identification-section"
                >
                    <img v-authenticated-image="item.fileName" />
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        item: {
            type: Object,
            default: null,
        },
    }, // End of Component > props
}
</script>
